<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Default</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <ul class="con-s list-none list-inline">
              <li>
                <vs-radio
                  v-model="radios1"
                  class="mx-2"
                  vs-name="radios1"
                  vs-value="luis"
                  >Luis</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  v-model="radios1"
                  class="mx-2"
                  vs-name="radios1"
                  vs-value="carols"
                  >Carols</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  v-model="radios1"
                  class="mx-2"
                  vs-name="radios1"
                  vs-value="summer"
                  >Summer</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  disabled="true"
                  class="mx-2"
                  v-model="radios1"
                  vs-name="radios1"
                  vs-value="lyon"
                  >Lyon - disabled</vs-radio
                >
              </li>
            </ul>
          </div>
        </div>
      </vs-col>

      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Color</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <ul class="con-s list-none list-inline">
              <li>
                <vs-radio v-model="radios2" class="mx-2" vs-value="primary"
                  >Primary</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  color="success"
                  class="mx-2"
                  v-model="radios2"
                  vs-value="Success"
                  >Success</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  color="danger"
                  class="mx-2"
                  v-model="radios2"
                  vs-value="Danger"
                  >Danger</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  color="warning"
                  class="mx-2"
                  v-model="radios2"
                  vs-value="Warning"
                  >Warning</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  color="dark"
                  class="mx-2"
                  v-model="radios2"
                  vs-value="Dark"
                  >Dark</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  color="rgb(87, 251, 187)"
                  class="mx-2"
                  v-model="radios2"
                  vs-value="RGB"
                  >RGB</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  color="#e48346"
                  class="mx-2"
                  v-model="radios2"
                  vs-value="HEX"
                  >HEX</vs-radio
                >
              </li>
            </ul>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
export default {
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: function () {
    return {
      radios1: "luis",
      radios2: "primary",
    };
  },
};
</script>